import { SparklesIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";

export const AutoBuchungTag = () => {
  return (
    <Badge className="text-xs m-1 gap-1 bg-high-confidence-bg border-high-confidence-border text-primary hover:bg-high-confidence-bg overflow-hidden text-ellipsis whitespace-nowrap">
      <SparklesIcon size={14} className="flex-shrink-0" />
      <span className="overflow-hidden text-ellipsis whitespace-nowrap">
        Auto
      </span>
    </Badge>
  );
};
